import { Injectable } from '@angular/core';
import {
  UserLoginModel,
  LogedInUserModel,
  UserSetNewPasswordModel,
  MembershipInsertModel,
  MembershipModel,
  MembershipPagedModel,
  PagerModel,
  MembershipInsertWithRoleModel,
  LoginExternalModel,
  NotificationMessageModel
} from 'src/app/models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ServiceHelpers } from 'src/app/shared/service.helpers';
import { GlobalConsts } from 'src/app/shared/global.vars';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private httpClient: HttpClient,
    private serviceHelpers: ServiceHelpers
  ) { }

  loginUser(input: UserLoginModel): Observable<LogedInUserModel> {
    return this.httpClient.post<LogedInUserModel>(
      GlobalConsts.apiBaseUrl + 'Membership/LoginUser',
      input,
      this.serviceHelpers.getCommonHeaders());
  }

  loginExternal(input: LoginExternalModel): Observable<LogedInUserModel> {
    return this.httpClient.post<LogedInUserModel>(
      GlobalConsts.apiBaseUrl + 'Membership/LoginExternal',
      input,
      this.serviceHelpers.getCommonHeaders());
  }

  reloginUser(input: LogedInUserModel): Observable<LogedInUserModel> {
    return this.httpClient.post<LogedInUserModel>(
      GlobalConsts.apiBaseUrl + 'Membership/ReLoginUser',
      input,
      this.serviceHelpers.getCommonHeaders());
  }

  forgotPassword(userName: string): Observable<boolean> {
    return this.httpClient.get<boolean>(
      GlobalConsts.apiBaseUrl + 'Membership/SendForgotPasswordEmail/' + userName,
      this.serviceHelpers.getCommonHeaders());
  }

  setNewPassword(input: UserSetNewPasswordModel): Observable<boolean> {
    return this.httpClient.post<boolean>(
      GlobalConsts.apiBaseUrl + 'Membership/SetNewPassword',
      input,
      this.serviceHelpers.getUpdateHeaders());
  }

  deleteUser(): Observable<any> {
    return this.httpClient.delete(
      GlobalConsts.apiBaseUrl + 'Membership/DeleteUser', {responseType: 'text'});
  }

  getTac(): Observable<any> {
    return this.httpClient.get(
      GlobalConsts.apiBaseUrl + 'Membership/GetTac', {responseType: 'text'});
  }

  getGdpr(): Observable<any> {
    return this.httpClient.get(
      GlobalConsts.apiBaseUrl + 'Membership/GetGdpr', {responseType: 'text'});
  }

  createPublicUser(input: MembershipInsertModel): Observable<MembershipModel> {
    return this.httpClient.post<MembershipModel>(
      GlobalConsts.apiBaseUrl + 'Membership/CreatePublicUser',
      input,
      this.serviceHelpers.getCreateHeaders());
  }

  confirmEmail(input: string): Observable<boolean> {
    return this.httpClient.get<boolean>(
      GlobalConsts.apiBaseUrl + 'Membership/ConfirmEmail/' + input,
      this.serviceHelpers.getCommonHeaders());
  }

  confirmNewUsername(input: string): Observable<NotificationMessageModel> {
    return this.httpClient.get<NotificationMessageModel>(
      GlobalConsts.apiBaseUrl + 'Membership/ConfirmUsernameChange/' + input,
      this.serviceHelpers.getCommonHeaders());
  }
}
